import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const MultiSelect = ({ id, label, values, selectedValues, onSelectChange }) => {
  // ✅ Convert values into select options
  const options = useMemo(() => {
    return values.map((val) => (typeof val === 'object' ? { value: val.nomenclatureCode, label: val.nomenclature } : { value: val, label: val }));
  }, [values]);

  // ✅ Handle selection change
  const handleChange = (selected) => {
    onSelectChange(id, selected ? selected.map((opt) => opt.value) : []);
  };

  return (
    <Select
      id={id}
      name={id}
      value={options.filter((option) => selectedValues.includes(option.value))} // ✅ Controlled by parent
      onChange={handleChange}
      options={options}
      isClearable
      isMulti
      menuPortalTarget={document.body}
      components={animatedComponents}
      placeholder={label}
      styles={{
        control: (base) => ({
          ...base,
          width: '300px' // Set specific width
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Set z-index
        menu: (base) => ({ ...base, zIndex: 9999 }) // Ensure dropdown appears above other elements
      }}
    />
  );
};

export default MultiSelect;
